
    import __i18nConfig from '@next-translate-root/i18n'
    import __appWithI18n from 'next-translate/appWithI18n'
    import { useContext } from 'react';
import { NextPage } from 'next';
import Head from 'next/head';
import { BrazeContentCard } from '~/components/BrazeContentCard';
import { FamilyChallengeComingSoon } from '~/components/familyChallenge/ComingSoon';
import { FeedbackFlow } from '~/components/feedback/FeedbackFlow';
import AppLayout from '~/components/layout/AppLayout';
import MobileDevicesInterstitial from '~/components/MobileDevicesInterstitial';
import { LpiCounterForPages, LpiStatCard } from '~/components/stats/LpisStatsCard';
import StreakCard from '~/components/streaks/StreakCard';
import { StreakCounterForPages } from '~/components/streaks/StreakCounter';
import PageDate from '~/components/ui/PageDate';
import WorkoutCardWrapper from '~/components/ui/WorkoutCard';
import { WorkoutModes } from '~/components/workout/WorkoutModes';
import { useZenMode } from '~/components/zen/useZenMode';
import { ZenModeAvailable } from '~/components/zen/ZenCards';
import { MarketingContext } from '~/context/MarketingContext';
import useTrackScreenView from '~/events/trackers/useTrackScreenView';
import { useGetUserQuery } from '~/graphql/generated/schema';
import useIsMobileDevice from '~/hooks/useIsMobileDevice';
import useLocalDate from '~/hooks/useLocalDate';
import useMarketingPageView from '~/hooks/useMarketingPageView';
import useScrollToTop from '~/hooks/useScrollToTop';
import useSetL2UserCookie from '~/hooks/useSetL2UserCookie';
import { useCommonTx } from '~/hooks/useTranslationForNamespace';
import { getPageProps } from '~/utils/nextPagePropUtils';
const Home: NextPage = () => {
    const t = useCommonTx('home');
    useTrackScreenView({ screen_name: 'home' });
    useMarketingPageView('home');
    useSetL2UserCookie();
    const zenData = useZenMode();
    zenData.trackOnceZenModeDetails({ location: 'today_content_card' });
    const { data: userQueryData } = useGetUserQuery({ fetchPolicy: 'cache-and-network' });
    const name = userQueryData?.me?.firstName;
    const { dateFormatted, greetingKey } = useLocalDate();
    const isMobileDevice = useIsMobileDevice();
    useScrollToTop();
    const { contentCards } = useContext(MarketingContext);
    const headerContentCard = contentCards.find((c) => c.extras?.page === 'home:header');
    const bodyContentCard = contentCards.find((c) => c.extras?.page === 'home:body');
    if (isMobileDevice) {
        return <MobileDevicesInterstitial />;
    }
    const greeting = name ? t(`greetingWithName.${greetingKey()}`, { name: name }) : t(`greeting.${greetingKey()}`);
    return (<>
      <AppLayout>
        <Head>
          <title>{t('title')}</title>
        </Head>
        <div className='flex flex-col gap-4 p-6 sm:p-10 w-full'>
          {headerContentCard && (<div className='mb-6'>
              <BrazeContentCard card={headerContentCard}/>
            </div>)}
          <div className='flex flex-row gap-4 flex-wrap'>
            <StreakCounterForPages />
            <LpiCounterForPages />
          </div>
          <PageDate dateString={dateFormatted}/>
          <div className='text-heading-1'>{greeting}</div>
          <div className='flex flex-col md:flex-row gap-10 xl:gap-16'>
            <div className='flex flex-col w-full max-w-[795px]'>
              <div className='w-full max-w-[592px] mt-4'>
                <WorkoutCardWrapper />
              </div>
              {bodyContentCard && (<div className='w-full max-w-[592px] mt-4'>
                  <BrazeContentCard card={bodyContentCard}/>
                </div>)}
              {zenData.featureEnabled && (<div className='w-full max-w-[592px] mt-5'>
                  <ZenModeAvailable />
                </div>)}
              <div className='mt-10'>
                <WorkoutModes />
              </div>

              <FamilyChallengeComingSoon className='w-full max-w-[592px] my-10'/>
            </div>
            <div className='w-full max-w-[326px] hidden lg:block'>
              <StreakCard />
              <div className='h-6 w-full'></div>
              <LpiStatCard layoutName='B'/>
            </div>
          </div>
        </div>
      </AppLayout>
      <FeedbackFlow />
    </>);
};
Home.getInitialProps = async (ctx) => {
    const pagePropsData = await getPageProps({ req: ctx.req });
    return {
        ...pagePropsData,
    };
};
const __Next_Translate__Page__197682ec7eb__ = Home;

    export default __appWithI18n(__Next_Translate__Page__197682ec7eb__, {
      ...__i18nConfig,
      isLoader: true,
      skipInitialProps: false,
      loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
    });
  